function calculateAdvancePurchaseWindow(departureDate) {
  const now = new Date()
  const departureDateObj = new Date(departureDate)
  const diffInMS = departureDateObj.getTime() - now.getTime()
  // Returns in DAYS
  return Math.abs(Math.ceil(diffInMS / (1000 * 3600 * 24)))
}

export { calculateAdvancePurchaseWindow }
